import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-3 min-vh-100 login-side-bar p-5 d-flex flex-column align-items-start" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/white-logo.png",
  class: "main-logo",
  alt: "Picado"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-white fw-bold mt-auto" }, [
  /*#__PURE__*/_createTextVNode(" Pick Fine. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Save Time ")
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}